<template>
  <div aria-live="polite" aria-atomic="true" class="visually-hidden">
    {{ message }}
  </div>
</template>

<script>
import { useLiveAnnouncer } from "@/composables/useLiveAnnouncer";

export default {
  name: "LiveAnnouncer",
  setup() {
    const { message } = useLiveAnnouncer();
    return { message };
  }
};
</script>
